import { Typography, type TypographyProps } from "@mui/material";

import { formatDate, formatDateTime, formatMoney, formatQuantity } from "../i18n/format";

type Base = Omit<TypographyProps, "children">;

export function MoneyText({ amount, currency, ...rest }: { amount: string | number | null | undefined; currency: string } & Base) {
  return <Typography component="span" variant="inherit" sx={{ fontVariantNumeric: "tabular-nums" }} {...rest}>{formatMoney(amount, currency)}</Typography>;
}

export function QuantityText({ value, uom, ...rest }: { value: string | number | null | undefined; uom?: string } & Base) {
  return <Typography component="span" variant="inherit" sx={{ fontVariantNumeric: "tabular-nums" }} {...rest}>{formatQuantity(value, uom)}</Typography>;
}

export function DateText({ value, withTime = false, ...rest }: { value: string | null | undefined; withTime?: boolean } & Base) {
  return <Typography component="span" variant="inherit" {...rest}>{withTime ? formatDateTime(value) : formatDate(value)}</Typography>;
}
